<template>
    <b-modal :active="showModal" :can-cancel="false" :width="560" scroll="keep">
        <div class="card">
            <div class="card-content has-text-centered">
                <p class="mb-4"><i class="fad fa-mobile-alt fa-3x has-text-warning"></i></p>
                <h2 class="title is-4">Small Screen Detected</h2>
                <p class="mb-4 has-text-grey">
                    It looks like you're using a phone or another device with a smaller screen. While you can
                    still use the site, the experience is sub-optimal on smaller screens and some features may
                    be difficult to use.
                </p>
                <p class="mb-2 has-text-weight-bold">
                    A desktop computer or large tablet is highly recommended.
                </p>
            </div>
            <footer class="card-footer">
                <div class="card-footer-item is-justify-content-center">
                    <b-button type="is-primary" @click="dismiss"><i class="fas fa-check mr-2"></i>I Understand, Continue</b-button>
                </div>
            </footer>
        </div>
    </b-modal>
</template>

<script>
    import {mapGetters} from "vuex";
    import {isPublicPath} from "@/router";

    const DISMISSED_KEY = 'small_screen_warning_dismissed';

    // Warn when the device itself is small (phones, small tablets). Screen
    // dimensions are used instead of the window so a desktop user with a
    // narrow browser window isn't nagged. 768px matches the app's existing
    // mobile breakpoint; large tablets (iPad and up) stay above it.
    function isSmallDevice() {
        return Math.min(window.screen.width, window.screen.height) < 768;
    }

    export default {
        name: "SmallScreenWarning",
        data: function() {
            return {
                dismissed: sessionStorage.getItem(DISMISSED_KEY) === '1'
            };
        },
        computed: {
            ...mapGetters(['currentUser']),
            showModal: function() {
                return !this.dismissed && !!this.currentUser && !isPublicPath(this.$route.path) && isSmallDevice();
            }
        },
        methods: {
            dismiss: function() {
                this.dismissed = true;
                sessionStorage.setItem(DISMISSED_KEY, '1');
            }
        }
    };
</script>
